import { Permission } from './permission';

export class Module {
  id: number;
  name: string;
  permissions: Permission[]=[];
}
